/* eslint-disable no-empty, no-restricted-globals */
import shared from './shared';

export default () => {
  const headerBurger = document.querySelector('.c-header__burger');

  if (headerBurger === null) {
    return;
  }

  headerBurger.addEventListener('click', event => {
    event.preventDefault();
    document.documentElement.classList.toggle(shared.CSS.menuOpen);
  });
};



// WEBPACK FOOTER //
// ./wp/wp-content/themes/elefint-redesign-chisel/src/scripts/modules/header.js